import FormFieldController from "confinus_ui/forms/form_field_controller";

// TODO need a radio group for validation.
export default class RadioController extends FormFieldController {}
